module.exports = __webpack_public_path__ + "static/media/attach-link.7ff29d73.svg";